
const AppConstants = {
    NEXT_STEP: "NEXT_STEP",
    FINDUS_NEXT_STEP: "FINDUS_NEXT_STEP",
    VALIDATE_FORM: "VALIDATE_FORM",
    ENABLE_ACCEPT_TERMS: "ENABLE_ACCEPT_TERMS",

    MODEL_S: "ModelS",
    MODEL_X: "ModelX",
    MODEL_3: "Model3",
    MODEL_Y: "ModelY",

    MODEL_S_LBL: "Model S",
    MODEL_X_LBL: "Model X",
    MODEL_3_LBL: "Model 3",
    MODEL_Y_LBL: "Model Y",

    // Image asset url
    RESOURCE_BASE_URL: (typeof window.tesla !== "undefined" ? window.tesla.resourceBaseUrl : ''),

    AGE_TO_DRIVE: {
        GB: 25,
    },

    ALLOWED_FILE_TYPES: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'],
    ALLOWED_PREVIEW_FILE_TYPES: ['image/png', 'image/jpeg', 'image/jpg'],
}

export default function Constants() {
    return AppConstants;
}